import React from "react";
import SysErrorCodeDetails from "../component/SysErrorCodeDetails";

const SysErrorCodeDetailsContainer = () => (<SysErrorCodeDetails />)

export default SysErrorCodeDetailsContainer;
